import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogModule, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

/**
 * 確認對話框數據介面
 *
 * @property {string} title - 對話框標題，若為空則預設為「確認」
 * @property {string} content - 對話框內容訊息
 * @property {boolean} result - 對話框結果（true=確定，false=取消）
 */
export interface ConfirmDialogData {
  title: string;// = '關於'; 其他則為 多行文字輸入
  content: string;
  result: boolean;
}

/**
 * 確認對話框組件
 *
 * 用於顯示一個帶有確定和取消按鈕的對話框，
 * 可用於需要用戶確認的操作，如刪除或提交等。
 *
 * 使用方式：
 * ```typescript
 * const dialogRef = this.dialog.open(ConfirmDialogComponent, {
 *   data: {
 *     title: '確認刪除',
 *     content: '您確定要刪除此項目嗎？',
 *     result: false
 *   }
 * });
 * ```
 */
@Component({
  standalone: true,
  imports: [MatDialogModule, MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,],
  selector: 'app-confirm-dialog',
  template: `
    <h2 mat-dialog-title>{{data.title}}</h2>
    <mat-dialog-content>{{data.content}}</mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button [mat-dialog-close]="true" (click)="doOk()">確定</button>
      <button mat-button [mat-dialog-close]="false" (click)="doCancel()">取消</button>
    </mat-dialog-actions>
  `,
})
export class ConfirmDialogComponent {
  dialogRef = inject<MatDialogRef<ConfirmDialogComponent>>(MatDialogRef);
  data = inject<ConfirmDialogData>(MAT_DIALOG_DATA);

  //public data: ConfirmDialogData = inject(MAT_DIALOG_DATA);
  constructor() {
    if(this.data.title === '') this.data.title = '確認';
}
  /**
   * 處理用戶點擊確定按鈕的操作
   * 設定結果為true並關閉對話框
   */
  doOk() {
    this.data.result = true;
    this.dialogRef.close(true);
  }

  /**
   * 處理用戶點擊取消按鈕的操作
   * 設定結果為false並關閉對話框
   */
  doCancel() {
    this.data.result = false;
    this.dialogRef.close(false);
    /*this.dialogRef.afterClosed().subscribe((result) =>{
      console.log('The dialog was closed');
      this.data.result = result;
    });
    */
  }
}
